import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

const USPCard = ({id, image, title, subTitle, showBackground}) => {

    return (
        <div key={id} className="media" styleName={"styles.mediaWrapper"}>
            <div styleName={`${showBackground ? "" : "styles.imageWrapper"} `}>
                <img src={image} />
            </div>
            <div className="media-body">
                <p styleName={"styles.heading"}>{title}</p>
                <p styleName={"styles.subHeading"}>{subTitle}</p>
            </div>
        </div>
    );
};

USPCard.propTypes = {
    id: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    showBackground: PropTypes.bool
};

export default React.memo(USPCard);
